import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

createUserModalStyles.cancelButton = {
    css: css`
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};

createUserModalStyles.submitButton = {
    css: css`
        margin-left: 1rem;
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("primary.contrast")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            background: ${getColor("text.accent")} !important;
            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};
createUserModalStyles.modal = {
    cssOverrides: {
        modalTitle: css`
            color: ${getColor("text.main")};
        `,
    },
};
createUserModalStyles.userNameVisibleGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.emailGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.firstNameGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.lastNameGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.roleGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.approverGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
createUserModalStyles.settingsHeadingGridItem = {
    width: 12,
    css: css`
        color: ${getColor("text.main")} !important;
    `,
};